import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateUgcSection } from "../../api/apiUgc";

export const useUpdateUgcSection = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateUgcSection(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["ugc-section"] });
            toast.success(response?.message || (isArabic ? "تم تحديث إعدادات UGC" : "UGC settings updated"));
        },
        onError: (error) => {
            const message = error?.response?.data?.message || (isArabic ? "تعذر التحديث" : "Failed to update");
            toast.error(message);
        },
    });

    return mutation;
};
